<div class="card mt-3 border-secondary bg-light">
    <div class="card-header bg-secondary text-white py-2 d-flex justify-content-between align-items-center">
        <h6 class="mb-0 small fw-bold">Configuración de Tasas por Categoría</h6>
        <button type="button" class="btn btn-sm btn-light py-0" (click)="addCategory()"
            [disabled]="categories.length >= 3">
            <span class="material-symbols-outlined align-middle fs-6">add</span> Categoría
        </button>
    </div>
    <div class="card-body p-2">
        <div *ngIf="categories.length === 0" class="text-center text-muted small p-2">
            No hay categorías configuradas.
        </div>

        <div *ngFor="let cat of categories; let i = index" class="card mb-2 border">
            <div class="card-header py-1 px-2 d-flex justify-content-between align-items-center bg-white">
                <div class="flex-grow-1 me-2">
                    <select class="form-select form-select-sm fw-bold border-0 bg-transparent"
                        [(ngModel)]="cat.category" (change)="emitChange()">
                        <option value="" disabled selected>Seleccione Categoría...</option>
                        <option *ngFor="let opt of categoryOptions" [value]="opt.value">
                            {{ opt.label }}
                        </option>
                    </select>
                </div>
                <button type="button" class="btn btn-sm text-danger p-0" (click)="removeCategory(i)">
                    <span class="material-symbols-outlined align-middle fs-6">delete</span>
                </button>
            </div>
            <div class="card-body p-2">
                <div class="mb-2 d-flex justify-content-between align-items-center">
                    <span class="small fw-semibold text-muted">Tasas por Edad</span>
                    <button type="button" class="btn btn-sm btn-outline-secondary py-0 px-1" style="font-size: 11px;"
                        (click)="addRate(i)">
                        <span class="material-symbols-outlined align-middle fs-6">add</span> Rango
                    </button>
                </div>

                <div *ngIf="cat.rates.length > 0" class="table-responsive">
                    <table class="table table-sm table-borderless mb-0 small">
                        <thead>
                            <tr class="text-muted">
                                <th style="width: 30%">Edad Desde</th>
                                <th style="width: 30%">Edad Hasta</th>
                                <th style="width: 30%">Tasa</th>
                                <th style="width: 10%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let rate of cat.rates; let j = index">
                                <td>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="rate.ageFrom"
                                        (blur)="emitChange()" placeholder="0">
                                </td>
                                <td>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="rate.ageTo"
                                        (blur)="emitChange()" placeholder="100">
                                </td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" [(ngModel)]="rate.rate"
                                        (blur)="emitChange()" mask="separator.4" thousandSeparator=","
                                        placeholder="0.0000">
                                </td>
                                <td class="text-end">
                                    <button type="button" class="btn btn-link text-danger p-0"
                                        (click)="removeRate(i, j)">
                                        <span class="material-symbols-outlined align-middle fs-6">close</span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="cat.rates.length === 0" class="text-center text-muted fst-italic py-1"
                    style="font-size: 11px;">
                    Agregue rangos de edad y tasas.
                </div>
            </div>
        </div>
    </div>
</div>